import React from "react";
import Layout from "components/Layout";

import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import store from "store";
import { Hooks } from "@xt/xtbase";
const { useIntl, FormattedMessage } = Hooks;
import getCommonStaticProps from "@xt/ssg";

import style from "./index.module.less";
import AntAlert from "components/Antd/Alert";
import StepOne from "components/Pages/ResetPassword/StepOne";
import StepTwo from "components/Pages/ResetPassword/StepTwo";
import StepThree from "components/Pages/ResetPassword/StepThree";
import Seo from "components/Seo";

export default observer(function PageRegister({ locale, tdk, resolvedUrl }) {
  const intl = useIntl();
  const router = useRouter();
  const { step = 1 } = router.query; // 1:设置用户名页面；2：安全验证页面；3：设置新
  const { isDark } = store.app;
  const themeStr = isDark ? "dark" : "light";
  return (
    <Layout>
      <Seo tdk={tdk} resolvedUrl={resolvedUrl} locale={locale} />

      <div className={`${style.main} ${themeStr}`}>
        {step != 2 && (
          <div className={style.pageAlert}>
            {" "}
            <AntAlert theme={themeStr} message={intl.formatMessage({ id: "resetPwd.tips" })} showIcon={true} type="warning">
              {" "}
            </AntAlert>{" "}
          </div>
        )}
        {step != 2 && (
          <h1 className={style.pageTitle}>
            {step == 1 && <FormattedMessage id="resetPwd.title" />}
            {step == 3 && <FormattedMessage id="resetPwd.titleSet" />}
          </h1>
        )}
        {step == 1 && <StepOne />}
        {step == 2 && (
          <div className={style.stepTwo}>
            <StepTwo />
          </div>
        )}
        {step == 3 && <StepThree />}
      </div>
    </Layout>
  );
});

export const getStaticProps = (context) => getCommonStaticProps(context, "/accounts/reset-password", { zE_show: true });
